import isEqual from 'lodash/isEqual'
import useDebounce from 'react-use/lib/useDebounce' // TODO: revert import change when this issue is resolved: https://github.com/streamich/react-use/issues/2074
import { useEffect, useRef, useState } from 'react'
import { useFormikContext } from 'formik'

export const FormAutoSubmitter = <T,>() => {
  const { values, submitForm, setSubmitting } = useFormikContext<T>()
  const [valuesToSubmit, setValuesToSubmit] = useState<T | null>(null)

  const ref = useRef<T | null>(null)

  useEffect(() => {
    if (ref.current && !isEqual(ref.current, values)) {
      setSubmitting(true)
      setValuesToSubmit(values)
    }
    ref.current = values
  }, [setSubmitting, values])

  useDebounce(() => valuesToSubmit && submitForm(), 500, [valuesToSubmit])

  return null
}
